<div class="pr" style="display: flex; flex-direction: row; gap: 15px">
  @if (tabTitle) {
    <div>
      @if (!expanded) {
        <i class="pi pi-chevron-down clickable" style="font-size: 14px;" (click)="expanded = !expanded; onExpandedChange()"></i>
      }
      @if (expanded) {
        <i class="pi pi-chevron-up clickable" style="font-size: 14px;" (click)="expanded = !expanded; onExpandedChange()"></i>
      }
    </div>
  }
    <div>
    @if (tabTitle) {
      <div class="block bold" style="font-size: 18px;">{{tabTitle}}</div>
    }
    @if (subTitle) {
      <div class="block bold" style="font-size: 14px;">{{subTitle}}</div>
    }
    @if (expanded) {
      <div class="dblock" style="display: flex; flex-direction: row; gap: 10px;">
          <div style="border: 1px solid #CCC; padding: 20px;">
              <div class="dblock bold">Allocations</div>
              <div class="pr-table block">
                  <mat-table matSort multiTemplateDataRows data-allocation-table [dataSource]="tableDataSource" [matSortActive]="config.sortMap[groupBy]?.column" [matSortDirection]="config.sortMap[groupBy]?.order" (matSortChange)="onSortChange($event)">
                      <ng-container cdkColumnDef="label">
                        <mat-header-cell *matHeaderCellDef data-group-sort mat-sort-header>
                  @if (groupBy == 'SEC_CATEGORY') {
                    <span>{{data.envGlobalSettingsDTO.securityCustAttrAbbr}}</span>
                  }
                  @if (groupBy !== 'SEC_CATEGORY') {
                    <span>Name</span>
                  }
                        </mat-header-cell>
                        <mat-footer-cell *matFooterCellDef>Totals</mat-footer-cell>
                        <mat-cell data-group *matCellDef="let row" [matTooltip]="null" [matTooltipDisabled]="true">
                          <div tooltip [tooltipTitle]="row.label" 
                          [tooltipRequiresTruncation]="true" tooltipPosition="right" 
                          style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
                    @if (row.showDetail && row.eqChildren && row.eqChildren.length > 0) {
                      <i class="pi pi-chevron-down clickable" style="font-size: 10px; margin-right: 5px;"></i>
                    }
                    @if (!row.showDetail && row.eqChildren && row.eqChildren.length > 0) {
                      <i class="pi pi-chevron-right clickable" style="font-size: 10px; margin-right: 5px;"></i>
                    }
                            {{row.label}}
                    @if (row.eqChildren && row.eqChildren.length > 0) {
                      <span>&nbsp;({{row.eqChildren.length}})</span>
                    }</div>
                        </mat-cell>
                      </ng-container>

                      <ng-container cdkColumnDef="group-child">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell data-group *matCellDef="let row">
                              <!--******* DETAIL ******************************-->
                              <mat-table data-allocation-detail-table class="detail" [dataSource]="getDataSource(row.eqChildren)">
                                  <ng-container cdkColumnDef="label">
                                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                    <mat-cell data-label *matCellDef="let row">
                                      <div tooltip [tooltipTitle]="row.label" [tooltipRequiresTruncation]="true" tooltipPosition="right" 
                                      style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; margin-left: 10px;">{{row.label}}</div>
                                    </mat-cell>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                  </ng-container> 

                                  <ng-container cdkColumnDef="beforeTotal">
                                    <mat-header-cell *matHeaderCellDef data-before-total-sort mat-sort-header>Current</mat-header-cell>
                                    <mat-cell data-before-total *matCellDef="let row"
                                                [innerText]="(row.beforeTotal | number: '1.2-2') + '%'"></mat-cell>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                  </ng-container>
                      
                                  <ng-container cdkColumnDef="color">
                                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                    <mat-cell data-color *matCellDef="let row">
                                      <div class="key" style.backgroundColor="#FFF"></div>
                                    </mat-cell>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                  </ng-container>

                                  <ng-container cdkColumnDef="colorSecondary">
                                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                    <mat-cell data-color *matCellDef="let row">
                                      <div class="key" style.backgroundColor="#FFF"></div>
                                    </mat-cell>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                  </ng-container>

                                  <ng-container cdkColumnDef="afterTotal">
                                    <mat-header-cell *matHeaderCellDef data-after-total-sort mat-sort-header>After</mat-header-cell>
                                    <mat-cell data-after-total *matCellDef="let row"
                                                [innerText]="(row.afterTotal | number: '1.2-2') + '%'"></mat-cell>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                  </ng-container>

                                  <ng-container cdkColumnDef="percentageChange">
                                    <mat-header-cell *matHeaderCellDef data-after-total-sort mat-sort-header>Adjustments</mat-header-cell>
                                    <mat-cell data-after-total *matCellDef="let row"
                                                [innerText]="(row.percentageChange | number: '1.2-2') + '%'" 
                        [class]="(row.percentageChange > 0) ? 'irb-green positive' : (row.percentageChange < 0) ? 'red' : ''"></mat-cell>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                  </ng-container>

                                  <ng-container cdkColumnDef="targetTotal">
                                    <mat-header-cell *matHeaderCellDef data-after-total-sort mat-sort-header>Target</mat-header-cell>
                                    <mat-cell data-after-total *matCellDef="let row"
                                                [innerText]="(row.targetTotal | number: '1.2-2') + '%'"></mat-cell>
                                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                                  </ng-container>  
                                  <mat-row data-allocation-detail-row *matRowDef="let row; columns: ['label', 'targetTotal', 'beforeTotal', 'color', 'percentageChange', 'afterTotal', 'colorSecondary']"></mat-row>
                              </mat-table>
                              <!--******* DETAIL ******************************-->
                        </mat-cell>  
                        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                      </ng-container>

                      <ng-container cdkColumnDef="beforeTotal">
                        <mat-header-cell *matHeaderCellDef data-before-total-sort mat-sort-header>Current</mat-header-cell>
                        <mat-cell data-before-total *matCellDef="let row"
                                    [innerText]="(row.beforeTotal | number: '1.2-2') + '%'"></mat-cell>
                        <mat-footer-cell *matFooterCellDef>{{(sumPercentagesBefore | number: '1.2-2') + '%'}}</mat-footer-cell>
                      </ng-container>
          
                      <ng-container cdkColumnDef="color">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell data-color *matCellDef="let row">
                            <div class="key" [style.backgroundColor]="row.color"></div>
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                      </ng-container>

                      <ng-container cdkColumnDef="colorSecondary">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell data-color *matCellDef="let row">
                            <div class="key" [style.backgroundColor]="row.colorSecondary"></div>
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                      </ng-container>

                      <ng-container cdkColumnDef="afterTotal">
                        <mat-header-cell *matHeaderCellDef data-after-total-sort mat-sort-header>After</mat-header-cell>
                        <mat-cell data-after-total *matCellDef="let row"
                                    [innerText]="(row.afterTotal | number: '1.2-2') + '%'"></mat-cell>
                        <mat-footer-cell *matFooterCellDef>{{(sumPercentagesAfter | number: '1.2-2') + '%'}}</mat-footer-cell>
                      </ng-container>

                      <ng-container cdkColumnDef="percentageChange">
                        <mat-header-cell *matHeaderCellDef data-after-total-sort mat-sort-header>Adjustments</mat-header-cell>
                        <mat-cell data-after-total *matCellDef="let row"
                                    [innerText]="(row.percentageChange | number: '1.2-2') + '%'" 
                  [class]="(row.percentageChange > 0) ? 'irb-green positive' : (row.percentageChange < 0) ? 'red' : ''"></mat-cell>
                        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                      </ng-container>

                      <ng-container cdkColumnDef="targetTotal">
                        <mat-header-cell *matHeaderCellDef data-after-total-sort mat-sort-header>Target</mat-header-cell>
                        <mat-cell data-after-total *matCellDef="let row"
                                    [innerText]="(row.targetTotal | number: '1.2-2') + '%'"></mat-cell>
                        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                      </ng-container>

                      <mat-footer-row *matFooterRowDef="tableColumns; sticky: false"></mat-footer-row>   
                      <mat-header-row *matHeaderRowDef="tableColumns; sticky: false"></mat-header-row>   
                      <mat-row data-allocation-table-row *matRowDef="let row; columns: tableColumns" (click)="toggleShowDetail(row)" class="clickable"></mat-row>
                <mat-row data-allocation-detail-row *matRowDef="let row; columns: ['group-child']; when: hasChildren" style="height: auto;" [style]="{display: (row.showDetail) ? 'block' : 'none'}"></mat-row>
                  </mat-table>
              </div>
              <div class="note">Note: Totals may not add to 100% due to rounding.</div>
          </div>
          @if (config.chartStyle == 'BAR_CHART') {
            <div style="border: 1px solid #CCC; width: 700px; padding: 20px;">
              <div class="dblock bold">Before and After Adjustments</div>
              <!--div style="overflow-y: auto; max-height: 240px;"-->
                  <p-chart type="bar" [data]="chartDataBarBeforeAndAfter" [options]="barChartOptions" [plugins]="plugins" [height]="barChartHeight" />
              <!--/div-->
          </div>
          }
          @if (config.chartStyle == 'PIE_CHART') {
            <div style="border: 1px solid #CCC; width: 700px; padding: 20px;">
              <div style="display: flex; flex-direction: row; gap: 50px;">
                  <div>
                      <div class="dblock bold">Current</div>
                      <p-chart type="doughnut" [data]="chartDataPieBefore" [options]="pieChartOptions" width="270px" height="270px"></p-chart>
                  </div>
                  <div>
                      <div class="dblock bold">After Adjustments</div>
                      <p-chart type="doughnut" [data]="chartDataPieAfter" [options]="pieChartOptions" width="270px" height="270px"></p-chart>
                  </div>
              </div>
          </div>
          }
      </div>
      }
    </div>
</div>
